var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProject2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_823_167266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.24998 0C3.69749 0 0 3.69749 0 8.24997C0 12.8025 3.69749 16.4999 8.24998 16.4999C12.8025 16.4999 16.5 12.8025 16.5 8.24997C16.5 3.69749 12.8025 0 8.24998 0ZM10.6275 9.08247L7.74748 10.7475C7.10248 11.115 6.30748 10.65 6.30748 9.91497V6.58505C6.30748 5.85006 7.10248 5.38506 7.74748 5.75256L10.6275 7.41755C11.265 7.78505 11.265 8.71497 10.6275 9.08247Z",
    fill: "#CAC4D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8746 19.5919L11.0473 23.9794C11.1151 23.9856 11.1806 24 11.2499 24H16.7203L13.8746 19.5919Z",
    fill: "#CAC4D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7499 8.99997H17.9699C17.6099 13.7775 13.7775 17.6099 8.99997 17.9699V21.7499C8.99997 22.3724 9.25497 22.9349 9.66747 23.3474L12.615 18.7799C12.8925 18.3524 13.3575 18.0899 13.875 18.0899C14.3925 18.0899 14.8575 18.3524 15.135 18.7799L17.6024 22.5974L18.6149 21.0299C18.8924 20.6024 19.3574 20.3399 19.8749 20.3399C20.3924 20.3399 20.8574 20.6024 21.1349 21.0299L22.8524 23.6924C23.5349 23.3099 23.9999 22.5824 23.9999 21.7499V11.25C23.9999 10.0125 22.9874 8.99997 21.7499 8.99997ZM17.9999 17.9999C17.1749 17.9999 16.5 17.3249 16.5 16.5C16.5 15.675 17.1749 15 17.9999 15C18.8249 15 19.4999 15.675 19.4999 16.5C19.4999 17.3249 18.8249 17.9999 17.9999 17.9999Z",
    fill: "#CAC4D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8746 21.8415L18.4955 23.9837L18.506 23.9999H21.2666L19.8746 21.8415Z",
    fill: "#CAC4D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_823_167266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject2);
export default __webpack_public_path__ + "static/media/project2.bffc0c75.svg";
export { ForwardRef as ReactComponent };